module.exports = __webpack_public_path__ + "swipper-3.png?7f9820f81c327d2124594fd6646648a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swipper-3.png
// module id = 180
// module chunks = 0